import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoginRequest } from '../../api/generated/identity/models/login-request';
import { TokenResponse } from '../../api/generated/identity/models/token-response';
import { GhUserProfileDto } from '../../api/generated/administration/models/gh-user-profile-dto';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Initialize Requested': emptyProps(),
    'Initialize Succeeded': props<{
      accessToken: string | null;
      profile: GhUserProfileDto | null;
      profileSyncedAt: string | null;
    }>(),
    'Initialize Failed': props<{ error: string }>(),
    'Login Requested': props<{ credentials: LoginRequest }>(),
    'Login Succeeded': props<{
      token: TokenResponse;
      profile: GhUserProfileDto;
      profileSyncedAt: string;
    }>(),
    'Login Failed': props<{ error: string }>(),
    'Refresh Requested': emptyProps(),
    'Refresh Succeeded': props<{ token: TokenResponse }>(),
    'Refresh Failed': props<{ error: string }>(),
    'Logout Requested': props<{ reason?: 'idle' | 'manual' }>(),
    'Session Cleared': props<{ reason?: 'idle' | 'manual' | 'expired' }>(),
  },
});
